<template>
  <div class="form-group">
    <div class="quota-fields">
      <div class="quota-field field-block" v-if="licenseApplication.paymentSum || licenseApplication.paymentDate || licenseApplication.paymentNumber">
        <p v-if="licenseApplication.paymentSum">{{ $t('Сумма оплаты за природопользование в сомах') }}: {{ licenseApplication.paymentSum }}</p>
        <p v-if="licenseApplication.paymentDate">{{ $t('Дата оплаты') }}: {{ licenseApplication.paymentDate }}</p>
        <p v-if="licenseApplication.paymentNumber">{{ $t('№ плат. поручения или № квитанции') }}: {{ licenseApplication.paymentNumber }}</p>
      </div>
      <div class="quota-field field-block" v-if="licenseApplication.blankPaymentSum || licenseApplication.blankPaymentDate || licenseApplication.blankPaymentNumber">
        <p v-if="licenseApplication.blankPaymentSum">{{ $t('Сумма оплаты за бланки в сомах') }}: {{ licenseApplication.blankPaymentSum }}</p>
        <p v-if="licenseApplication.blankPaymentDate">{{ $t('Дата оплаты') }}: {{ licenseApplication.blankPaymentDate }}</p>
        <p v-if="licenseApplication.blankPaymentNumber">{{ $t('№ плат. поручения или № квитанции') }}: {{ licenseApplication.blankPaymentNumber }}</p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    licenseApplication: Object
  },
  data: () => ({})
}
</script>
